import { zodResolver } from '@hookform/resolvers/zod';
import { useMemo, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from 'react-router';
import { Form } from 'softcat:components/form.tsx';
import { LocationService } from 'softcat:services/location.ts';
import * as z from 'zod';

export const LocationsCreate = () => {
    const intl = useIntl();
    const navigate = useNavigate();
    const [submitting, setSubmitting] = useState(false);
    const [onCreateError, setOnCreateError] = useState('');

    const CreateLocationSchema = z.object({
        active: z.boolean(),
        description: z.string().optional(),
        name: z.string().refine(
            (value) => {
                return value.length >= 2 && value.length <= 64 && /^[\dA-Za-z-_/.]+$/.test(value);
            },
            {
                message: intl.formatMessage({ id: 'LOCATIONS_FORM_NAME_VALIDATION_ALPHANUMERIC' }),
            },
        ),
    });

    const onSubmit = async (values: z.infer<typeof CreateLocationSchema>) => {
        setSubmitting(true);
        setOnCreateError('');

        try {
            await LocationService.create(values);

            setSubmitting(false);

            return navigate('/locations');
        } catch (error) {
            setSubmitting(false);
            setOnCreateError((error as Error).message);
        }
    };

    const defaultValues = useMemo(() => {
        return { active: true, description: '', name: '' };
    }, []);

    return (
        <Form<z.infer<typeof CreateLocationSchema>> defaultValues={defaultValues} onSubmit={onSubmit} resolver={zodResolver(CreateLocationSchema)}>
            <div className="space-y-3 px-4">
                <Form.Header
                    description={<FormattedMessage id={'LOCATIONS_CREATE_PAGE_DESCRIPTION'} />}
                    title={<FormattedMessage id={'LOCATIONS_CREATE_PAGE_HEADING'} />}
                />

                <Form.Input label={<FormattedMessage id={'LOCATIONS_FORM_NAME_LABEL'} />} name={'name'} />

                <Form.Input label={<FormattedMessage id={'LOCATIONS_FORM_DESCRIPTION_LABEL'} />} name={'description'} />

                <Form.Checkbox label={<FormattedMessage id={'LOCATIONS_FORM_ACTIVE_LABEL'} />} name={'active'} />

                <Form.Footer
                    isSubmitting={submitting}
                    onCancel={() => {
                        return navigate('/locations');
                    }}
                    submitError={onCreateError && <FormattedMessage id={'LOCATIONS_CREATE_PAGE_FORM_SUBMIT_ERROR'} values={{ error: onCreateError }} />}
                    submitText={<FormattedMessage id={'BUTTON_CREATE'} />}
                />
            </div>
        </Form>
    );
};
